module.exports = {
  init: function() {
    return this.xf['@@transducer/init']();
  },
  result: function(result) {
    return this.xf['@@transducer/result'](result);
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/html-to-react/~/ramda/src/internal/_xfBase.js
// module id = kj6u
// module chunks = 0